<template>
  <div style="display: inline;">
    <top-bar-search></top-bar-search>
    <top-bar-alert></top-bar-alert>
  </div>
</template>

<script>
  import TopBarSearch from './TopBar/TopBarSearch.vue'
  import TopBarAlert from './TopBar/TopBarAlert.vue'

  export default {
    components: {
      TopBarAlert,
      TopBarSearch
    },
    name: 'main-custom-top-bar'
  }
</script>



// WEBPACK FOOTER //
// MainCustomTopBar.vue?cfe8ad84